import { DATA, KEY, REQUIRED_STRING, Resource } from "shelving";
import { CHALLENGE_FORM_SCHEMA, LIST_FORM_SCHEMA, NOTE_FORM_SCHEMA, REWARD_FORM_SCHEMA, REWARD_SCHEMA } from "shared/schema";

export const CREATE_CHALLENGE = new Resource("createChallenge", CHALLENGE_FORM_SCHEMA, KEY);
export const EDIT_CHALLENGE = new Resource("editChallenge", DATA({ id: KEY, ...CHALLENGE_FORM_SCHEMA.props }));

export const CREATE_REWARD = new Resource("createReward", DATA({ type: REWARD_SCHEMA.props.type, ...REWARD_FORM_SCHEMA.props }), KEY);
export const EDIT_REWARD = new Resource("editReward", DATA({ id: KEY, ...REWARD_FORM_SCHEMA.props }));

export const CREATE_LIST = new Resource("createList", LIST_FORM_SCHEMA, REQUIRED_STRING);
export const EDIT_LIST = new Resource("editList", DATA({ id: KEY, ...LIST_FORM_SCHEMA.props }));
export const DELETE_LIST = new Resource("deleteList", DATA({ id: KEY }));

export const CREATE_NOTE = new Resource("createNote", NOTE_FORM_SCHEMA, REQUIRED_STRING);
export const EDIT_NOTE = new Resource("editNote", DATA({ id: KEY, ...NOTE_FORM_SCHEMA.props }));
export const DELETE_NOTE = new Resource("deleteNote", DATA({ id: KEY }));
